const dev1 = {
    baseURL: "http://localhost:7418",
     uploads_cdn:"https://d1osfq4ya4myls.cloudfront.net",
     netsuite_url: "https://5615243-sb1.app.netsuite.com",
    env: "uat",
};
const dev = {
    baseURL: "http://34.197.161.10:7418",
     uploads_cdn:"https://d1osfq4ya4myls.cloudfront.net",
     netsuite_url: "https://5615243-sb1.app.netsuite.com",
    env: "uat",
};
 
const uat = {
    baseURL: "https://prod-api.magnasalespro.com",
     uploads_cdn:"https://d1osfq4ya4myls.cloudfront.net",
     netsuite_url: "https://5615243-sb1.app.netsuite.com",
    env: "uat",
};
module.exports = uat;
 